import { verifyPoints } from "@/mocks/homeData";

export default function VerifySection() {
  return (
    <section id="verify" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-shield-check-line" />
            官网识别
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            六个要点，帮你避开仿冒网站
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            网络上存在模仿官方外观的仿冒页面。它们往往通过细微的域名差异或诱导性弹窗来混淆。掌握下面几点，可以大幅降低误入风险。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {verifyPoints.map((item) => (
            <div
              key={item.title}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={item.icon} />
              </span>
              <h3 className="mt-5 font-heading text-foreground-950 text-lg">{item.title}</h3>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}